import styled from '@emotion/styled';
import { Region } from '@kaizenplatform/hugot-entity';
import { Meta } from '@kaizenplatform/hugot-entity/dist/entity/DynamicSchemaDefinition/IDynamicSchemaSection';
import {
  Button,
  Dialog as _Dialog,
  DialogActions as _DialogActions,
  DialogContent as _DialogContent,
  useMediaQuery,
} from '@material-ui/core';
import { createElement, FC, MouseEvent, MouseEventHandler, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { SearchAssetResult } from '../../../entity/SearchAsset';
import theme from '../../../theme';
import mq from '../../styleUtility/mediaquery';
import { PreparedMaterialSelector } from './SearchAsset/PreparedMaterialSelector';

type Props = {
  meta: Meta;
  region: Region;
  isOpen: boolean;
  onClose: MouseEventHandler<HTMLElement>;
  onSubmit: (e: MouseEvent<HTMLElement>, selectedSearchAssetResult: SearchAssetResult[number] | null) => void;
};

const SearchFileUploaderDialog: FC<Props> = ({ isOpen, onClose, onSubmit, meta, region }) => {
  const [selectedSearchAsset, setSelectedSearchAsset] = useState<SearchAssetResult[number] | null>(null);
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);

  return (
    <Dialog onClose={onClose} open={isOpen} maxWidth="lg" fullWidth={true} fullScreen={!isPC}>
      <DialogContent>
        <PreparedMaterialSelector
          meta={meta}
          region={region}
          selectedSearchAsset={selectedSearchAsset}
          setSelectedSearchAsset={setSelectedSearchAsset}
        />
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          color="default"
          onClick={(e) => {
            setSelectedSearchAsset(null);
            onClose(e);
          }}
        >
          <FormattedMessage id="search_file_uploader.selector.cancel" />
        </Button>
        <Button
          disabled={selectedSearchAsset == null}
          size="small"
          onClick={(e) => {
            onSubmit(e, selectedSearchAsset);
          }}
        >
          <FormattedMessage id="search_file_uploader.selector.submit" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// PC版の時、モーダルがチャットボックスと被らないように、大きさを小さくする。
// SP版の時はモーダルが全画面取るように表示したいので、marginを0に戻す。
const Dialog = styled(_Dialog)`
  margin: 48px;
  ${mq('sp')} {
    margin: 0;
  }
  .MuiDialog-paperWidthLg {
    max-width: 1280px;
  }
`;

const DialogContent = styled(_DialogContent)`
  min-width: 960px;
  ${mq('sp')} {
    width: 100%;
    min-width: 100%;
    padding: 8px 16px;
  }
`;

// SP版の時だけボタンの位置をチャットボックスと被らないように位置を上にずらす
const DialogActions = styled(_DialogActions)`
  ${mq('sp')} {
    margin-bottom: 96px;
  }
`;

export default SearchFileUploaderDialog;
